import React, {FC} from "react";
import {Button, Typography} from "@material-ui/core";
import {Content} from "view/components/Form";
import FfairModal from "view/components/modal/FfairModal";
import FfairPaper from "view/components/FfairPaper";
import FlexBox from "view/components/Layout/FlexBox";

type DeleteMessageModalProps = {
  deleteType: string;
  handleClose: () => void;
  handleSubmit: () => void;
  open: boolean;
};

const DeleteMessageModal: FC<DeleteMessageModalProps> = ({
  deleteType,
  handleClose,
  handleSubmit,
  open,
}) => {
  const onClose = () => {
    handleClose();
  };
  const calledByModal = true;
  const onSubmit = async () => {
    handleSubmit();
    handleClose();
  };

  return (
    <FfairModal
      open={open}
      onClose={onClose}
      isCalledByAnotherModal={calledByModal}
    >
      <FfairPaper style={{width: 480, padding: "24px 24px 16px 24px"}}>
        <Typography variant="h2">{`Delete this ${deleteType}?`}</Typography>
        <Content>
          <FlexBox
            style={{
              paddingTop: "16px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={onClose}
              variant="text"
              color="primary"
              style={{
                marginRight: "1em",
              }}
            >
              Cancel
            </Button>
            <Button onClick={onSubmit} variant="contained" color="primary">
              Delete
            </Button>
          </FlexBox>
        </Content>
      </FfairPaper>
    </FfairModal>
  );
};

export default DeleteMessageModal;
